/**
 * EB 分栏布局菜单工具（移植 view/mer/src/utils/system.js）
 */
import type { RouteLocationNormalized } from 'vue-router';
import { ensureMerchantPrefix, getCrmebRouteLookupPath, type CrmebNavMenuItem } from '@/utils/crmebMenu';

function getPath(to: RouteLocationNormalized, path: string) {
  const params: string[] = [];
  const query: string[] = [];
  Object.keys(to.params || {}).forEach((item) => {
    params.push(String(to.params[item]));
  });
  Object.keys(to.query || {}).forEach((item) => {
    query.push(`${item}=${to.query[item]}`);
  });
  return path + (params.length ? `/${params.join('/')}` : '') + (query.length ? `?${query.join('&')}` : '');
}

function transferMenu(menu: CrmebNavMenuItem, headerName: string) {
  if (menu.children?.length) {
    return menu.children.reduce<Array<{ path: string; header: string }>>((all, item) => {
      all.push({ path: item.path, header: headerName });
      return all.concat(transferMenu(item, headerName));
    }, []);
  }
  return [{ path: menu.path, header: headerName }];
}

/** 根据当前路由找到顶栏（分栏）菜单 path */
export function getHeaderName(to: RouteLocationNormalized, menuList: CrmebNavMenuItem[]): string | null {
  const allMenus: Array<{ path: string; header: string }> = [];
  menuList.forEach((menu) => {
    const headerName = menu.path || '';
    const menus = transferMenu(menu, headerName);
    allMenus.push({ path: menu.path, header: headerName });
    menus.forEach((item) => allMenus.push(item));
  });
  const path = getCrmebRouteLookupPath(to);
  const currentMenu = allMenus.find((item) => {
    const menuPath = ensureMerchantPrefix(item.path);
    if (menuPath === path) return true;
    return path === getPath(to, menuPath);
  });
  return currentMenu ? currentMenu.header : null;
}

export function getMenuSider(menuList: CrmebNavMenuItem[], headerName = '') {
  if (headerName) {
    return menuList.filter((item) => item.path === headerName);
  }
  return menuList;
}

export function findFirstNonNullChildren(arr: CrmebNavMenuItem[] | null | undefined): CrmebNavMenuItem | null {
  if (!arr?.length) return null;
  const firstObj = arr[0];
  if (!firstObj.children?.length) return firstObj;
  return findFirstNonNullChildren(firstObj.children);
}

/** 多级嵌套数组处理成一维数组（对齐 EB view/mer/src/utils/system.js） */
export const formatFlatteningRoutes = (arr: unknown[]) => {
  if (!Array.isArray(arr) || arr.length <= 0) return false;
  let list = arr as Array<Record<string, unknown>>;
  for (let i = 0; i < list.length; i++) {
    const children = list[i].children as typeof list | undefined;
    if (children) {
      list = list.slice(0, i + 1).concat(children, list.slice(i + 1));
    }
  }
  return list;
};
